<template>
    <div class="combined-container">
        <div class="design-section">
            <div class="wave-background"></div>
            <div class="content-wrapper">
                <div class="update-box">
                    <p class="update-text">{{ updateText }}</p>
                </div>
                <p class="subtitle">15社<span>から厳選</span></p>
                <h2 class="title">おすすめ給湯器業者<span class="top-5">TOP5</span></h2>
                <div class="divider"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CombinedDesign',
    data() {
        return {
            updateText: '',
        };
    },
    created() {
        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        this.updateText = `${year}年${month}月更新`;
    },
};
</script>

<style scoped>
.title-box {
    background-color: #0e3d7a;
    color: white;
    padding: 10px 30px;
    border-radius: 5px;
    margin-bottom: 20px;
}

.title-text {
    font-size: 24px;
    font-weight: bold;
    margin: 0;
    letter-spacing: 2px;
}

.selection-criteria-box {
    display: flex;
    align-items: baseline;
    color: white;
}

.number {
    font-size: 6rem;
    font-weight: bold;
    color: #ffc107;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    margin-right: 10px;
    line-height: 1;
}

.text-and-criteria-wrapper {
    transform: translateY(-20px);
}

.criteria-text,
.text {
    font-size: 2.5rem;
    font-weight: bold;
    color: white;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
    line-height: 1;
}

.text {
    margin-right: 5px;
}

.design-section {
    position: relative;
    width: 100%;
    padding-top: 50px;
    padding-bottom: 20px;
    background-color: #eef5ff;
    text-align: center;
}

.wave-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background-color: #fff9f1;
    border-bottom-left-radius: 80% 100px;
    border-bottom-right-radius: 80% 100px;
}

.content-wrapper {
    position: relative;
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.update-box {
    background-color: #0e3d7a;
    color: white;
    padding: 8px 20px;
    border-radius: 3px;
    margin-top: -20px;
}

.update-text {
    font-size: 30px;
    font-weight: bold;
    margin: 0;
}

.subtitle {
    font-size: 50px;
    font-weight: 900; 
    color: #ff8c00; 
    /* text-shadow:
        -1px -1px 0 #fff, 
        1px -1px 0 #fff,
        -1px 1px 0 #fff,
        1px 1px 0 #fff,
        2px 2px 4px rgba(0, 0, 0, 0.3); */
    margin: 10px 0;
    margin-bottom: 0;
}

.top-5 {
    font-size: 50px; 
    font-weight: 900; 
    color: #ff8c00; 
    /* text-shadow:
        -1px -1px 0 #fff, 
        1px -1px 0 #fff,
        -1px 1px 0 #fff,
        1px 1px 0 #fff,
        2px 2px 4px rgba(0, 0, 0, 0.3); */
}

.title {
    font-size: 40px;
    font-weight: 900;
    color: #3f51b5; 
    /* text-shadow:
        -2px -2px 0 #fff,
        2px -2px 0 #fff,
        -2px 2px 0 #fff,
        2px 2px 0 #fff,
        3px 3px 6px rgba(0, 0, 0, 0.4);  */
    margin: 5px 0;
    line-height: 0.7; 
    padding-bottom: 10px;
}

.subtitle span {
    font-size: 35px;
    font-weight: 900;
    color: #3f51b5;
    /* text-shadow:
        -2px -2px 0 #fff,
        2px -2px 0 #fff,
        -2px 2px 0 #fff,
        2px 2px 0 #fff,
        3px 3px 6px rgba(0, 0, 0, 0.4);  */
}

.divider {
    width: 80%;
    max-width: 500px;
    height: 1px;
    border-bottom: 3px dashed #888;
    margin-top: 1px;
}

.scroll-text {
    padding-right: 10px;
    margin: 0;
    text-align: right;
    font-size: 15px;
    background: #f0f8ff;
}

@keyframes blinking {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.blink {
    animation: blinking 1s ease-in-out infinite alternate;
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {
    .update-text {
        font-size: 1.2rem;
    }

    .subtitle span, .title{
        font-size: 1.6rem;
    }

    .subtitle, .top-5{
        font-size: 2rem;
    }
}
</style>